import { Controller } from "@hotwired/stimulus"

import { formatPrice } from "@/helpers/price_format"

const BOOK_NOW_CTA = "Book now"
const APPLY_CTA = "Apply"

export default class extends Controller {
  static targets = ["priceSummary", "submitButton", "totalPrice"]
  declare readonly priceSummaryTarget: HTMLElement
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly totalPriceTarget: HTMLElement

  static values = {
    calendarFormId: String,
    calendarLastStep: Boolean,
    paxFormId: String,
    purchaseFormId: String
  }
  declare readonly calendarFormIdValue: string
  declare readonly calendarLastStepValue: boolean
  declare readonly paxFormIdValue: string
  declare readonly purchaseFormIdValue: string

  private purchaseCtaText: string = BOOK_NOW_CTA

  connect(): void {
    this.purchaseCtaText = window.location.pathname.includes("/venues") ? BOOK_NOW_CTA : APPLY_CTA

    if (this.purchaseCtaText === APPLY_CTA) {
      this.submitButtonTarget.textContent = this.purchaseCtaText
    }
  }

  setCalendarSubmit({
    isDateSelected,
    allSelected
  }: {
    isDateSelected: boolean
    allSelected: boolean
  }): void {
    const formId =
      this.calendarLastStepValue || allSelected
        ? this.purchaseFormIdValue
        : this.calendarFormIdValue
    const nextStepText = this.calendarLastStepValue || allSelected ? this.purchaseCtaText : "Next"
    const buttonText = isDateSelected ? nextStepText : "Select date"

    this.updateSubmitButton(formId, buttonText, !isDateSelected)
    this.priceSummaryTarget.hidden = !allSelected || !isDateSelected
  }

  setFacilitiesSubmit(isFacilitySelected: boolean): void {
    const buttonText = isFacilitySelected ? this.purchaseCtaText : "Select facility use"

    this.updateSubmitButton(this.purchaseFormIdValue, buttonText, !isFacilitySelected)
    this.priceSummaryTarget.hidden = false // Always visible as facility selection does not affect price
  }

  setPriceTarget(value: number): void {
    this.totalPriceTarget.textContent = formatPrice(value)
  }

  setPaxSubmit(readyToSubmit: boolean): void {
    if (readyToSubmit) {
      this.updateSubmitButton(this.purchaseFormIdValue, this.purchaseCtaText, false)
      this.priceSummaryTarget.hidden = false
    } else {
      this.updateSubmitButton(this.paxFormIdValue, "Next", false)
      this.priceSummaryTarget.hidden = true
    }
  }

  setRoomsSubmit(isAllRoomsSelected: boolean): void {
    const buttonText = isAllRoomsSelected ? this.purchaseCtaText : "Select rooms"

    this.updateSubmitButton(this.purchaseFormIdValue, buttonText, !isAllRoomsSelected)
    this.priceSummaryTarget.hidden = !isAllRoomsSelected
  }

  private updateSubmitButton(formId: string, textContent: string, disabled: boolean): void {
    this.submitButtonTarget.setAttribute("form", formId)
    this.submitButtonTarget.textContent = textContent
    this.submitButtonTarget.disabled = disabled
  }
}
